var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBelowTheFold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 96,
    viewBox: "0 0 140 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7082_300464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.358 12H3.23699C1.44925 12 0 13.3431 0 15V63C0 64.6568 1.44925 66 3.23699 66H136.358C138.146 66 139.595 64.6568 139.595 63V15C139.595 13.3431 138.146 12 136.358 12Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "black-triangle",
    d: "M63.7437 45.1562C64.1505 45.1562 64.4962 45.0145 64.903 44.8107L76.7602 38.8391C77.6043 38.4049 77.8992 38.1214 77.8992 37.6518C77.8992 37.1822 77.6043 36.8987 76.7602 36.4734L64.903 30.4929C64.4962 30.2892 64.1505 30.1562 63.7437 30.1562C62.9912 30.1562 62.5234 30.6524 62.5234 31.4232V43.8804C62.5234 44.6513 62.9912 45.1562 63.7437 45.1562Z",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.358 69H3.23699C1.44925 69 0 70.3431 0 72C0 73.6569 1.44925 75 3.23699 75H136.358C138.146 75 139.595 73.6569 139.595 72C139.595 70.3431 138.146 69 136.358 69Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6069 78H3.23699C1.44925 78 0 79.3431 0 81C0 82.6569 1.44925 84 3.23699 84H35.6069C37.3947 84 38.8439 82.6569 38.8439 81C38.8439 79.3431 37.3947 78 35.6069 78Z",
    fill: "#4F4C57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7082_300464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 72,
    fill: "white",
    transform: "translate(0 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBelowTheFold);
export default __webpack_public_path__ + "static/media/icon-below-the-fold.8903dd1e4f07b427cd66c26871241753.svg";
export { ForwardRef as ReactComponent };